module.exports = __webpack_public_path__ + "static/restaurant-a08649a373c6e3c8bedbe3a7442bde17.jpg";